import { render, staticRenderFns } from "./ChanPx.vue?vue&type=template&id=5c45a868&scoped=true"
import script from "./ChanPx.vue?vue&type=script&lang=js"
export * from "./ChanPx.vue?vue&type=script&lang=js"
import style0 from "./ChanPx.vue?vue&type=style&index=0&id=5c45a868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c45a868",
  null
  
)

export default component.exports